import React from 'react'
import '../styles/contact.css'
import image from '../images/baner3.jpg'
const ContactPage = () => {
    return (
        <div>
            <img src={image} className="w-100" alt="Responsive" />
            <div id="section3" className="container contact">
                <h1 className="text-center">kontakt.</h1>
                <div className="row">
                    <div className="col-sm">
                        <ul>
                            <li><strong>MP Projekt Malwina Pietrzak</strong></li><br></br>
                            <li>NIP: 8291743849</li>
                            <li>REGON: 381898589</li><br></br>
                            <li>98-161 Zapolice/ woj. łódzkie</li>
                            <li>Strońsko 65</li><br></br>
                            <li>tel: <strong>606351245</strong></li>
                            <li>e-mail: <strong>malwina_pietrzak@wp.pl</strong></li>
                            <li>facebook: <strong>MP Projekt</strong></li>
                            <li><a href="https://www.facebook.com/MP-Projekt-1195364477286081/"><i className="fab fa-facebook-square"></i></a></li>
                        </ul>
                    </div>
                    <div className="col-sm" style={{ width: "100%" }}><iframe title="stronsko" width="100%" height="400" src="https://maps.google.com/maps?width=100%&amp;height=400&amp;hl=en&amp;q=Stro%C5%84sko%2065+(Stro%C5%84sko%2065)&amp;ie=UTF8&amp;t=&amp;z=12&amp;iwloc=B&amp;output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe></div>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;